"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useChatUIState: ()=>useChatUIState
});
const external_react_namespaceObject = require("react");
const useChatUIState = ()=>{
    const [showSurvey, setShowSurvey] = (0, external_react_namespaceObject.useState)(false);
    const [openErrorComponent, setOpenErrorComponent] = (0, external_react_namespaceObject.useState)(false);
    const [isMapOpened, setIsMapOpened] = (0, external_react_namespaceObject.useState)(false);
    return {
        showSurvey,
        setShowSurvey,
        openErrorComponent,
        setOpenErrorComponent,
        isMapOpened,
        setIsMapOpened
    };
};
exports.useChatUIState = __webpack_exports__.useChatUIState;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useChatUIState"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
